//@flow
import React from 'react';
import PropTypes from 'prop-types';
import {Tabs, Tab} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {colors} from '../../../../../assets/styles/colors';

type Props = {|
  value: number,
  onChange?: (event: SyntheticEvent<{}>) => void,
  labels: string[],
|};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    backgroundColor: colors.grey300,
    borderRadius: '40px',
    padding: '4px ',
    width: 'fit-content',
    margin: '3px',
  },
  customTab: {
    textTransform: 'none',
    minWidth: 72,
    minHeight: '20px',
    margin: '4px',
    fontWeight: theme.typography.fontWeightRegular,
  },
  activeTab: {
    color: colors.purple3,
    backgroundColor: 'white',
    borderRadius: '124px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.04), 0px 2px 4px rgba(96, 97, 112, 0.16)',
  },
  indicator: {
    backgroundColor: 'transparent',
  },
  rootTabs: {
    [theme.breakpoints.down('sm')]: {
      margin: 'auto',
    },
  },
}));

export default function Switch(props: Props) {
  const {value, onChange, labels} = props;
  const classes = useStyles();

  return (
    <Tabs
      value={value}
      onChange={onChange}
      classes={{
        root: classes.rootTabs,
        indicator: classes.indicator,
      }}
      textColor="primary"
      className={classes.tabs}
      variant="scrollable"
    >
      <Tab
        label={labels[0]}
        style={{marginRight: '0px'}}
        classes={{root: classes.customTab, selected: classes.activeTab}}
      />
      <Tab
        label={labels[1]}
        style={{marginLeft: '0px'}}
        classes={{root: classes.customTab, selected: classes.activeTab}}
      />
    </Tabs>
  );
}

Switch.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  labels: PropTypes.array,
};
